import * as Yup from "yup";

export const schema = Yup.object().shape({
  oldPassword: Yup.string().required("Este campo es requerido"),
  confirmNewPassword: Yup.string()
    .required("Este campo es requerido")
    .oneOf(
      [Yup.ref("newPassword"), null],
      "La nueva contraseña y su confirmación deben coincidir"
    ),
  newPassword: Yup.string()
    .required("Este campo es requerido")
    .notOneOf(
      [Yup.ref("oldPassword")],
      "La nueva contraseña debe ser diferente a la contraseña actual"
    )
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/,
      "Debe contener 8 caracateres, uno en mayúscula, uno en minúscula, un número y un caracter especial."
    ),
});

interface FormValues {
  oldPassword: string;
  confirmNewPassword: string;
  newPassword: string;
}

export const initialValues: FormValues = {
  oldPassword: "",
  confirmNewPassword: "",
  newPassword: "",
};
